import React from 'react';
import { Button, Grid, TextField } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import { format } from 'date-fns';

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  button: {
    marginTop: 24,
    marginRight: '24px',
    paddingTop: '8px',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingBottom: '8px',
  }
});

class NotificationDetailForm extends React.Component {
  render() {
    const classes = this.props.classes;
    const smallDeviceSize = 960;

    // alert('Called with subject ' + this.props.notificationSubject);

    let fieldWidth = "50%";
    if (window.innerWidth < smallDeviceSize ) {
      fieldWidth = "90%";
    }

    return (
      <div style={{width: '100%', height: 500}}>
        <Grid container spacing={2} justifyContent="space-around" style={{marginTop:'35px'}}  align="center">
          <Grid item xs={12}>
            <TextField 
              id="notification-time" label="Timestamp"
              value={ format(new Date(this.props.notificationTime+'Z'), 'yyyy-MM-dd pp') }
              style={{width: fieldWidth}}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              id="notification-subject" label="Subject"
              value={ this.props.notificationSubject }
              style={{width: fieldWidth}}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              multiline={true}
              minRows={5}
              maxRows={20} 
              id="notification-body" label="Detail"
              value={ this.props.notificationBody }
              style={{width: fieldWidth}}
            />
          </Grid>
          <Grid item xs={12}>
            <Button color="primary" variant="contained"  onClick={() => {this.props.onClose()}}  className={classes.button} >Close</Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default  withStyles(styleSheet)(NotificationDetailForm);
